// Topbar global search strings — EN + TR (Admin + Seller lenses).

import type { LocalizedDict } from '../index'

type GlobalSearchStrings = {
  triggerAdmin: string
  triggerSeller: string
  openLabel: string
  title: string
  placeholderAdmin: string
  placeholderSeller: string
  typeMore: string
  searching: string
  failed: string
  retry: string
  noResults: (q: string) => string
  noResultsHintAdmin: string
  noResultsHintSeller: string
  keyboardHint: string
  groups: {
    screens: string
    recent: string
    orders: string
    products: string
    stores: string
    suppliers: string
    sellers: string
  }
  orderPrefix: string
  showProducts: string
  showInStores: string
  seeAll: string
  clearRecent: string
  emptyHint: string
  goToScreen: string
  orgTypes: Record<string, string>
  matched: {
    tracking: (v: string) => string
    email: (v: string) => string
    product: (v: string) => string
  }
}

export const globalSearchI18n: LocalizedDict<GlobalSearchStrings> = {
  en: {
    triggerAdmin: 'Search orders, products, stores, suppliers',
    triggerSeller: 'Search orders, products, stores',
    openLabel: 'Open search',
    title: 'Search',
    placeholderAdmin: 'Order no, tracking, customer, email, SKU, product, store, seller, screen…',
    placeholderSeller: 'Order no, tracking, customer, email, product, your SKU, screen…',
    typeMore: 'Type at least 2 characters.',
    searching: 'Searching…',
    failed: 'Search failed.',
    retry: 'Try again',
    noResults: (q) => `Nothing matches “${q}”.`,
    noResultsHintAdmin:
      'Try an order number (5123), a marketplace order id, a customer name, a SKU or a product code.',
    noResultsHintSeller:
      'Try an order number (5123), a marketplace order id, a customer name, a product name or your own SKU.',
    keyboardHint: '↑ ↓ to move · Enter to open · Esc to close',
    groups: {
      screens: 'Screens',
      recent: 'Recently opened',
      orders: 'Orders',
      products: 'Products',
      stores: 'Stores',
      suppliers: 'Suppliers',
      sellers: 'Sellers',
    },
    orderPrefix: 'Order',
    showProducts: 'Show products',
    showInStores: 'Show in stores',
    seeAll: 'See all',
    clearRecent: 'Clear',
    emptyHint: 'Search orders, tracking numbers, customers, products, stores — or type a screen name.',
    goToScreen: 'Go to',
    orgTypes: { BO1: 'Internal store', BO2: 'Seller', BO3: 'B2B buyer' },
    matched: {
      tracking: (v) => `Tracking ${v}`,
      email: (v) => `Email ${v}`,
      product: (v) => `Contains: ${v}`,
    },
  },
  tr: {
    triggerAdmin: 'Sipariş, ürün, mağaza, tedarikçi ara',
    triggerSeller: 'Sipariş, ürün, mağaza ara',
    openLabel: 'Aramayı aç',
    title: 'Ara',
    placeholderAdmin: 'Sipariş no, takip no, müşteri, e-posta, SKU, ürün, mağaza, satıcı, ekran…',
    placeholderSeller: 'Sipariş no, takip no, müşteri, e-posta, ürün, kendi SKU’n, ekran…',
    typeMore: 'En az 2 karakter yaz.',
    searching: 'Aranıyor…',
    failed: 'Arama yapılamadı.',
    retry: 'Tekrar dene',
    noResults: (q) => `“${q}” ile eşleşen bir şey yok.`,
    noResultsHintAdmin:
      'Sipariş numarası (5123), pazar yeri sipariş no, müşteri adı, SKU ya da ürün kodu dene.',
    noResultsHintSeller:
      'Sipariş numarası (5123), pazar yeri sipariş no, müşteri adı, ürün adı ya da kendi SKU’nu dene.',
    keyboardHint: '↑ ↓ gezin · Enter aç · Esc kapat',
    groups: {
      screens: 'Ekranlar',
      recent: 'Son açılanlar',
      orders: 'Siparişler',
      products: 'Ürünler',
      stores: 'Mağazalar',
      suppliers: 'Tedarikçiler',
      sellers: 'Satıcılar',
    },
    orderPrefix: 'Sipariş',
    showProducts: 'Ürünlerini göster',
    showInStores: 'Mağazalarda göster',
    seeAll: 'Tümünü gör',
    clearRecent: 'Temizle',
    emptyHint: 'Sipariş, takip no, müşteri, ürün, mağaza ara — ya da bir ekran adı yaz.',
    goToScreen: 'Git',
    orgTypes: { BO1: 'İç mağaza', BO2: 'Satıcı', BO3: 'B2B alıcı' },
    matched: {
      tracking: (v) => `Takip no ${v}`,
      email: (v) => `E-posta ${v}`,
      product: (v) => `İçeriyor: ${v}`,
    },
  },
}
